import React from 'react';
import {withRouter} from 'react-router-dom';
import {Alert} from 'componentLibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {STATUS_PENDING_SUBMISSION} from 'app-ui-componentlibrary/dist/common/constants';
import {Dimmer, Loader} from 'semantic-ui-react';
import {checkProcessInstanceTerminated, cancelSubCloseoutReport} from 'common/utils';
class CancelSubCloseoutReportModal extends React.Component {
  state = {
    open: false,
    cancelling: false,
    message: '',
    selectedGrantId: '',
  };

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps) {
    this.refreshData();
  }

  refreshData() {
    const {open, token, entity} = this.props;
    const {selectedGrantId} = this.state;
    let subGrantId = entity.subGrantId;

    if (!_.isEqual(selectedGrantId, subGrantId)) {
      this.setState({
        selectedGrantId: subGrantId,
        message: '',
        open: this.props.open,
      });
    } else if (!_.isEqual(open, this.state.open)) {
      this.setState({open: this.props.open});
    }
  }

  handleConfirm = () => {
    const {token, entity, history, referrer} = this.props;
    const {selectedGrantId} = this.state;
    this.setState({cancelling: true});
    REST.dynamicData
      .getBySubGrantIdAndEntityType(token, selectedGrantId, 'subCloseoutReport')
      .then(REST.handler.handleResponse)
      .then((reportEntity) => {
        //Revert using UI components
        reportEntity =
          reportEntity.constructor === Array ? reportEntity[0] : reportEntity;
        if (reportEntity.status === STATUS_PENDING_SUBMISSION) {
          cancelSubCloseoutReport(reportEntity, token, (cancelling, message) => {
            if (message === '') {
              this.setState({open: false, cancelling: cancelling, message: message});
              this.props.onCancel();
              window.location.reload(false);
            } else {
              this.setState({cancelling: cancelling, message: message});
              console.error(message);
            }
          });
        } else {
          //Revert using workflow signal
          const data = {
            entity: reportEntity,
            selectedGrantId: selectedGrantId,
          };
          REST.workflow
            .sendSignalForSubGrant(token, data, `revert-subCloseout-report`)
            .then(REST.handler.handleResponse)
            .then((res) => {
              let processInstanceId = _.isObject(res) ? _.get(res, 'result') : res;
              if (processInstanceId != undefined) {
                //existing workflow. report was submitted before
                checkProcessInstanceTerminated(
                  reportEntity,
                  token,
                  processInstanceId,
                  (entity) => {
                    this.setState({open: false, cancelling: false, message: ''}, () => {
                      this.props.onCancel();
                      window.location.reload(false);
                    });
                  }
                );
              }
            })
            .catch((error) => {
              this.setState({
                cancelling: false,
                message:
                  'An error happened while trying to revert this subgrant to its post-award state.',
              });
              console.error(
                'An error happened while trying to revert this subgrant to its post-award state: ' +
                  'error'
              );
            });
        }
      })
      .catch((error) => {
        this.setState({
          cancelling: false,
          message:
            'An error happened while trying to revert this subgrant to its post-award state.',
        });
        console.error(
          'An error happened while trying to revert this subgrant to its post-award state: ' +
            'error'
        );
      });
  };

  handleCancel = () => {
    const cancel = () => this.props.onCancel();
    this.setState({open: false, selectedGrantId: ''});
    cancel();
  };

  render() {
    const {entity} = this.props;

    const {open, cancelling, selectedGrantId, message} = this.state;

    return (
      open && (
        <FemaGoModal
          type="alert"
          size="medium"
          title="Revert subgrant to post-award state"
          className="modal-title"
          open={open}
          confirmAction={this.handleConfirm}
          buttonText="Confirm"
          cancelButtonText="Cancel"
          buttonType={'primary'}
          cancelAction={this.handleCancel}
        >
          <hr />
          {!_.isEmpty(message) && (
            <Alert header="" htmlContent={message} alertType="error" />
          )}
          {cancelling && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
          <p>
            <strong>{`Subgrant ID:  ${selectedGrantId}`}</strong>
          </p>
          <p>
            {`By returning to the post-award phase, you will lose any work you have performed on your subgrant closeout report.`}
          </p>
          <br />
        </FemaGoModal>
      )
    );
  }
}

export default withRouter(CancelSubCloseoutReportModal);
